import { render } from "./App.vue?vue&type=template&id=71c55daa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=71c55daa&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__